import { translate } from "app/filters/i18nFilter";
import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";

export const timeGranularityObjects = {
    daily: { title: "D", disabled: false, name: "Daily", index: 0 },
    weekly: { title: "W", disabled: false, name: "Weekly", index: 1 },
    monthly: { title: "M", disabled: false, name: "Monthly", index: 2 },
};

export const deviceTypeToTextMap = {
    get [devicesTypes.DESKTOP]() {
        return translate("paidsearch.adspend.device.desktop");
    },
    get [devicesTypes.MOBILE]() {
        return translate("paidsearch.adspend.device.mobile");
    },
    get [devicesTypes.TOTAL]() {
        return translate("paidsearch.adspend.device.total");
    },
};
